import { useState } from 'react';
import * as S from './style';
//icons
import { Check, Invoice } from '@phosphor-icons/react';
//components
import ActionButton from "../../../Button/ActionButton";
import Invoices from "../../Invoices/Details";
//hooks
import { useMultipleModal } from '../../../../hooks/useMultipleModal';
//interfaces
import { IPayments, IPromotion } from 'Interfaces/IOrder';
import FormatarData from 'utils/FormatData';

interface IDetails {
    type_product: string,
    count: number,
    code: string,
    value_unit: string,
    amount: number,
    payment: IPayments[],
    promotion: IPromotion,
    total: string,
}
export default function DetailsProduct({
    type_product,
    count,
    code,
    value_unit,
    amount,
    total,
    payment,
    promotion,
}: IDetails) {

    const { isOpenModal, toggleModalVisibility } = useMultipleModal();
    const [installmentsIds, setInstallmentsIds] = useState([]);

    const clickInvoices = (product_installments: any) => {
        setInstallmentsIds(product_installments);
        toggleModalVisibility("invoices");
    };

    return (
        <S.Container>
            <S.Header>
                <S.Title>{type_product}</S.Title>
                <S.Count>{count}</S.Count>
            </S.Header>
            <S.Content>
                <S.Section>
                    <S.ContentInfor>
                        <S.Infor isTitle={true}>Nome</S.Infor>
                        <S.Infor isTitle={false}>{code}</S.Infor>
                    </S.ContentInfor>
                    <S.ContentInfor>
                        <S.Infor isTitle={true}>Valor Unitário</S.Infor>
                        <S.Infor isTitle={false}>{value_unit}</S.Infor>
                    </S.ContentInfor>
                    <S.ContentInfor>
                        <S.Infor isTitle={true}>Quantidade</S.Infor>
                        <S.Infor isTitle={false}>{amount} und.</S.Infor>
                    </S.ContentInfor>
                </S.Section>

                <S.FeaturedContent>
                    <S.TitleFeatured>
                        <Check size={16} />
                        Pagamento
                    </S.TitleFeatured>
                    {
                        payment.map((pay, index) => (
                            <S.Section key={index}>
                                <S.ContentInfor>
                                    <S.Infor isTitle={true}>Método</S.Infor>
                                    <S.Infor isTitle={false}>
                                        {pay.method || '-'}
                                        {
                                            pay.installment_on_credit_card_id && (`(${pay.installment_on_credit_card_id?.number_installment}x)` || '-')
                                        }
                                    </S.Infor>
                                </S.ContentInfor>

                                {
                                    pay.installment_on_credit_card_id &&
                                    <S.ContentInfor>
                                        <S.Infor isTitle={true}>Taxa</S.Infor>
                                        <S.Infor isTitle={false}>
                                            {
                                                pay.installment_on_credit_card_id?.interest_rate || '-'
                                            }%
                                        </S.Infor>
                                    </S.ContentInfor>
                                }

                                <S.ContentInfor>
                                    <S.Infor isTitle={true}>Valor</S.Infor>
                                    <S.Infor isTitle={false}>{pay.amount || 0}</S.Infor>
                                </S.ContentInfor>

                                {
                                    (pay.method.toLocaleLowerCase() === "crediário da loja" || pay.method.toLocaleLowerCase() === "crediário") &&
                                    <>
                                        <S.ContentInfor>
                                            <S.Infor isTitle={true}>Entrada</S.Infor>
                                            <S.Infor isTitle={false}>
                                                Valor: {pay.down_payment || 0}
                                            </S.Infor>
                                        </S.ContentInfor>

                                        <S.ContentInfor>
                                            <S.Infor isTitle={true}>Primeira Parcela</S.Infor>
                                            <S.Infor isTitle={false}>{FormatarData(pay.first_due_date, 'default-data')}</S.Infor>
                                        </S.ContentInfor>

                                        <S.ContentInfor>
                                            <S.Infor isTitle={true}>Pagamentos da Entrada</S.Infor>
                                            {
                                                pay.combined_down_payments && pay.combined_down_payments.map((val, index) => (
                                                    <S.Section>
                                                        <S.Infor isTitle={false}>
                                                            {index + 1} - {val.method}
                                                            {val.installment_on_credit_card && `(${val.installment_on_credit_card.number_installment}x)`}: {val.amount}
                                                        </S.Infor>
                                                    </S.Section>
                                                ))
                                            }
                                        </S.ContentInfor>

                                        <S.ContentInfor>
                                            <S.Infor isTitle={true}>Qtd. de Parcelas</S.Infor>
                                            {pay.number_installments || 0}
                                        </S.ContentInfor>
                                    </>
                                }

                                {
                                    (pay.installments_detail && pay.installments_detail?.length > 0) &&
                                    <S.ContentInfor>
                                        <S.Infor isTitle={true}>Faturas</S.Infor>
                                        <ActionButton
                                            Icon={<Invoice size={20} />}
                                            name="Ver Faturas"
                                            onClick={() => clickInvoices(pay.installments_detail)}
                                        />
                                    </S.ContentInfor>
                                }
                            </S.Section>
                        ))
                    }

                    {
                        promotion &&
                        (<>
                            <S.TitleFeatured>
                                <Check size={16} />
                                Promoção
                            </S.TitleFeatured>
                            <S.ContentInfor>
                                <S.Infor isTitle={true}>Nome</S.Infor>
                                <S.Infor isTitle={false}>{promotion.title || '-'}</S.Infor>
                            </S.ContentInfor>
                            <S.Section>
                                <S.ContentInfor>
                                    <S.Infor isTitle={true}>Tipo</S.Infor>
                                    <S.Infor isTitle={false}>{promotion.type || '-'}</S.Infor>
                                </S.ContentInfor>

                                <S.ContentInfor>
                                    <S.Infor isTitle={true}>Desconto</S.Infor>
                                    <S.Infor isTitle={false}>{promotion.discount_value || 0}</S.Infor>
                                </S.ContentInfor>
                            </S.Section>
                        </>)
                    }
                </S.FeaturedContent>
            </S.Content>

            <S.Footer>Total: {total}</S.Footer>

            <Invoices
                isOpenModalDetails={isOpenModal("invoices")}
                setModalClose={() => toggleModalVisibility("invoices")}
                dataInvoices={installmentsIds}
            />
        </S.Container>
    )
}
// return null;